import React from "react";
import { SiteHeader, SiteFooter } from "../components/SiteChrome";
import { useBrand } from "../context/BrandContext";

export default function Privacy() {
  const s = useBrand();
  return (
    <div>
      <SiteHeader />
      <div className="max-w-3xl mx-auto px-5 py-16">
        <h1 className="font-heading font-extrabold text-navy text-3xl md:text-4xl tracking-tight" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <p className="mt-4 text-sm text-slate-400">Last updated: June 2026</p>

        <p className="mt-6 text-slate-600 leading-relaxed" data-testid="privacy-intro">
          {s.privacy_policy ||
            "We respect your privacy. This policy explains what information we collect when you use the Trisha Wealth Financial Health Check-Up, how we use it, and the choices you have."}
          {" "}
          At {s.business_name || "Trisha Wealth"}, protecting the personal and financial information you
          share with us is a responsibility we take seriously. The Financial Health Check-Up is an
          educational tool designed to help you understand your financial strengths and gaps, and any
          information you provide is used solely to prepare your report and, with your consent, to discuss
          your financial planning needs.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">Information We Collect</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">
          When you complete the check-up we collect the answers you provide to the 12 assessment questions,
          along with contact details you choose to share such as your name, mobile number, email address,
          city, age group and income range. Providing optional details like your goals, dependents and
          existing investments helps us personalise your report but is entirely voluntary. We do not ask
          for, and you should never share, sensitive information such as passwords, bank account numbers,
          card details or one-time passwords.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">How We Use Your Information</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Your responses are used to calculate your Financial Health Score, identify your top financial
          priorities and generate a personalised improvement report. If you give consent, we may contact
          you to discuss your results and how a structured financial plan could help you close the gaps
          identified. We use aggregated, anonymised data to improve the assessment experience. We do not
          sell, rent or trade your personal information to third parties.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">How We Protect Your Data</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Information is transmitted over encrypted connections and stored securely with access restricted
          to authorised team members. We retain your data only for as long as needed to provide our services
          and to comply with our legal and regulatory obligations, after which it is securely deleted.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">Your Rights &amp; Choices</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">
          You may request access to, correction of, or deletion of the personal information we hold about
          you, and you can withdraw your consent to be contacted at any time. To exercise any of these
          rights, simply reach out using the contact details below and we will respond promptly.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">Contact Us</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">
          If you have any questions about this privacy policy or how your information is handled, please
          contact {s.advisor_name || s.business_name || "Trisha Wealth"}
          {s.email ? ` at ${s.email}` : ""}
          {s.website ? ` or visit ${s.website}` : ""}.
        </p>

        <h2 className="mt-10 font-heading font-bold text-navy text-xl">Disclaimer</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">{s.disclaimer}</p>
      </div>
      <SiteFooter />
    </div>
  );
}
